import { createAction, props } from '@ngrx/store';

import { IFileMetaData } from '../../reducers/tax-document-upload/tax-document-upload.reducer';

export const updateTaxFilesMetaData = createAction(
  '[Tax Document Upload] Update Files Metadata',
  props<{ payload: IFileMetaData[] }>(),
);

// Restores file metadata from a saved draft. Same reasoning as
// restoreTaxCheckboxSelections below: this must NOT mark isL8ITWUploadPageVisited.
// Restoring files the user uploaded in an earlier session does not mean they have
// visited the page this session, and the router keys off that flag — marking it here
// made resuming a draft skip the very L8/ITW page the restored files belong to.
export const restoreTaxFilesMetaData = createAction(
  '[Tax Document Upload] Restore Files Metadata',
  props<{ payload: IFileMetaData[] }>(),
);

export const clearTaxFilesMetaData = createAction('[Tax Document Upload] Clear Files Metadata');

export const updateTaxCheckboxSelections = createAction(
  '[Tax Document Upload] Update Checkbox Selections',
  props<{
    payload: {
      mailingForm?: boolean;
      beneficiarySubmitted?: boolean;
      noFormNeeded?: boolean;
    };
  }>(),
);

// Restores checkbox selections from a saved draft. Unlike updateTaxCheckboxSelections
// (dispatched when the user interacts with the L8/ITW page), this must NOT mark
// isL8ITWUploadPageVisited — restoring a saved answer is not the same as the user
// having visited the page this session, and the router relies on that flag to decide
// whether to route them there again.
export const restoreTaxCheckboxSelections = createAction(
  '[Tax Document Upload] Restore Checkbox Selections',
  props<{
    payload: {
      mailingForm?: boolean;
      beneficiarySubmitted?: boolean;
      noFormNeeded?: boolean;
    };
  }>(),
);
